module.exports = __webpack_public_path__ + "files/fe8e455b00383f7f6aaa05896d051c3d.png";